import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import * as rd from "diacritics"

import {
  Table,
  Glyphicon,
  Well,
  Button,
  Grid,
  Row,
  Col,
  Thumbnail,
  Pagination,
  Image,
} from 'react-bootstrap';

import If from "../../utils/If"
import PaginationComponent from "../../utils/pagination-component"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-publications.css'
import '../../statics/css/util.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { publicationsList, updatePublication } from '../../dao-firebase/publication-firebase'

const itensOnPage = 10;

class TablePublications extends Component {

  constructor(props) {
    super(props);

    this.state = {

      publications: [],

      //modal select training
      //selected_training_modal: undefined,

      //Pagination countItensAlunos
      publiCount: undefined,
      //pgination
      beginPagination: 1,
      endPagination: itensOnPage,
      activePage: 1,
      indexOk: true,
    };

  }

  componentDidMount() {

  }

  componentWillMount() {
    publicationsList(JSON.parse(localStorage.getItem("USER")).uid, (response) => {

      //console.table(this.state.trainings)

      this.setState({
        publications: response,
        publiCount: response.length,
      }, () => {

        //console.log(this.state.trainings)
      })
    })
  }

  convertDate(date) {

    let convertedDate = new Date(date * 1000).toLocaleDateString("pt-BR");
    return convertedDate;
  }

  trainingDetail(training) {

    this.props.handleDetailTraining(training);

    //this.props.history.push("/treino/montar");
  }

  verifySearch(obj) {

    let nameObjFormat = rd.remove(obj.name.toLowerCase());
    let searchFormat = rd.remove(this.props.search.toLowerCase());
    return nameObjFormat.includes(searchFormat);
  }

  handleDetailTrainingModal(training) {

    this.props.handleDetailTrainingModal(training);
  }

  selectTrainingModal(training) {

    this.props.handleSelectTrainingModal(training)
  }

  onChangePagination(p, begin, end) {

    this.setState({
      beginPagination: begin,
      endPagination: end,
      activePage: p,
    }, () => {
      console.log("Active: ", this.state.activePage,
        " - Begin: ", this.state.beginPagination,
        " - End: ", this.state.endPagination)
    })

  }

  renderPublicationsCards() {

    return _.map(this.state.publications, (publication) => {

      return (

        <Col xs={3}>

          <div className="card card-publication">
            {/* <div className="center-cropped3"> */}
            <div className="center-croppedSquare">
              <Image src={publication.data.url_image} className={`${publication.data.status == "active" ? '' : 'opacity-inactive'}`} />
            </div>
            <div className="infos-card">
              <div className={`title-and-date-publication ${publication.data.status == "active" ? '' : 'opacity-inactive'}`}>
                <h4>{publication.data.title}</h4>

              </div>

              <div className="publi-date-filter">
                <p className={`text-left ${publication.data.status == "active" ? '' : 'opacity-inactive'}`}><Glyphicon glyph="calendar" /> {publication.data.date_create ?
                  this.convertDate(publication.data.date_create.seconds)
                  :
                  ""}</p>

                <If test={publication.data.filter == "consult"}>
                  <p className={`filter-publi ${publication.data.status == "active" ? '' : 'opacity-inactive'}`}>Consultoria</p>
                </If>
                <If test={publication.data.filter == "all"}>
                  <p className={`filter-publi ${publication.data.status == "active" ? '' : 'opacity-inactive'}`}>Todos</p>
                </If>
                <If test={publication.data.filter == "personal"}>
                  <p className={`filter-publi ${publication.data.status == "active" ? '' : 'opacity-inactive'}`}>Personal</p>
                </If>

              </div>

              <p className={`block-with-text ${publication.data.status == "active" ? '' : 'opacity-inactive'}`}>{publication.data && publication.data.text ? publication.data.text.toString() : ''}</p>
              <div className="actions-publication">

                <p onClick={() => this.props.editPublication(publication)} className={`edit-publi ${publication.data.status == "active" ? 'active' : 'opacity-inactive'}`}>Editar <Glyphicon glyph="pencil" /></p>

                {
                  publication.data.status == "active" ?
                    <p onClick={() => {
                      publication.data.status = "inactive";
                      this.props.updatePublication(publication)
                    }}
                      className="inactive-button">Inativar <Glyphicon className="icon-publi active" glyph="off" /></p>
                    :
                    <p onClick={() => {
                      publication.data.status = "active";
                      this.props.updatePublication(publication)
                    }}
                      className="inactive-button">Ativar <Glyphicon className="icon-publi inactive" glyph="off" /></p>

                }

              </div>
            </div>
          </div>

        </Col>
      )
    })
  }

  render() {

    return (
      <div className="table-publications" >

        {/* <ul className="ul-training-list">
          {this.renderTrainings()}


        </ul> */}

        {/* <Grid>
          <Row className="row-publications">
            {this.renderPublicationsCards()}
          </Row>
        </Grid> */}
        {/* <Table responsive>
          <thead>
            <tr>
              <th>Imagem</th>
              <th>Título/Descrição</th>
              <th className="text-center">Criação</th>
            </tr>
          </thead>
          <tbody>
            {this.renderPublications()}
          </tbody>
        </Table> */}
        <div className="publications-div">
          <Grid>
            <Row>
              {this.renderPublicationsCards()}
            </Row>
          </Grid>
        </div>



        < If test={this.state.publiCount} >
          {/*this.renderPagination()*/}
          < PaginationComponent
            beginPagination={1}
            endPagination={12}
            countItens={this.state.publiCount}
            activePage={1}
            itensOnPage={12}
            onChangePage={(p, begin, end) => this.onChangePagination(p, begin, end)} />
        </If >

      </div >
    );
  }
}

export default TablePublications;



// WEBPACK FOOTER //
// src/components/feed/table-publications.js